import React from "react";
import { Instagram, Music2, Youtube, Facebook } from "lucide-react";

/** Configure your real social handles here — same names as your ad platforms. */
const socials = [
  { name: "Instagram", handle: "@novalynxtech", url: "https://instagram.com/novalynxtech", icon: Instagram, color: "from-pink-500/40 to-purple-500/20" },
  { name: "TikTok", handle: "@novalynxtech", url: "https://www.tiktok.com/@novalynxtech", icon: Music2, color: "from-cyan-500/40 to-fuchsia-500/20" },
  { name: "YouTube", handle: "@novalynxtech", url: "https://youtube.com/@novalynxtech", icon: Youtube, color: "from-red-500/40 to-orange-500/20" },
  { name: "Facebook", handle: "NovalynxTech", url: "https://facebook.com/novalynxtech", icon: Facebook, color: "from-blue-500/40 to-sky-500/20" },
];

export default function SocialStrip() {
  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 py-16 border-t border-white/5" data-testid="social-strip">
      <div className="text-center mb-8">
        <p className="chip mx-auto mb-3 border-primary/40 text-primary">Follow us</p>
        <h2 className="font-display text-3xl md:text-4xl font-bold tracking-tight">
          See the drops first
        </h2>
        <p className="text-muted-foreground text-sm mt-2 max-w-md mx-auto">
          Unboxings, real-life setups and behind-the-scenes on our channels.
        </p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {socials.map((s) => (
          <a
            key={s.name}
            href={s.url}
            target="_blank"
            rel="noreferrer"
            className={`relative rounded-2xl bg-gradient-to-br ${s.color} border border-white/10 hover:border-primary/40 p-6 text-center overflow-hidden transition-all group`}
            data-testid={`social-${s.name.toLowerCase()}`}
          >
            <s.icon className="h-6 w-6 mx-auto text-white mb-3 group-hover:scale-110 transition-transform" />
            <p className="font-semibold text-sm">{s.name}</p>
            <p className="text-xs text-muted-foreground">{s.handle}</p>
          </a>
        ))}
      </div>
    </section>
  );
}
